import { render, staticRenderFns } from "./create.vue?vue&type=template&id=45cb2216&scoped=true&"
import script from "./create.vue?vue&type=script&lang=ts&"
export * from "./create.vue?vue&type=script&lang=ts&"
import style0 from "./create.vue?vue&type=style&index=0&id=45cb2216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cb2216",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsSlider } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VContainer,VFlex,VIcon,VListTile,VListTileTitle,VTab,VTabItem,VTabs,VTabsSlider})
